import { Component, computed, inject, signal } from '@angular/core';
import { NgClass, TitleCasePipe } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from '../../auth/auth.service';
import { LayoutService } from '../layout.service';

export interface NavItem {
  label: string;
  route: string;
  module?: string;
  iconUrl: string;
}

const NAV_ITEMS: NavItem[] = [
  {
    label: 'Dashboard',
    route: '/dashboard',
    iconUrl: '/icons/dashboard-icon.svg',
  },
  {
    label: 'Incidents',
    route: '/incidents',
    module: 'Incidents',
    iconUrl: '/icons/info-icon.svg',
  },
  // {
  //   label: 'Investigations',
  //   route: '/investigations',
  //   module: 'Investigations',
  //   iconUrl: '/icons/search-icon.svg',
  // },
  // {
  //   label: 'Persons',
  //   route: '/persons',
  //   module: 'Persons',
  //   iconUrl: '/icons/people-icon.svg',
  // },
  {
    label: 'Investigations',
    route: '/investigations',
    module: 'Investigations',
    iconUrl: '/icons/search-icon.svg',
  },
  {
    label: 'Search',
    route: '/search',
    module: 'Search',
    iconUrl: '/icons/unified-search-icon.svg',
  },
  {
    label: 'Directory',
    route: '/persons',
    module: 'Persons',
    iconUrl: '/icons/persons-icon.svg',
  },
  {
    label: 'Configuration',
    route: '/configuration',
    module: 'Configuration',
    iconUrl: '/icons/gear-icon.svg',
  },
];

@Component({
  selector: 'app-sidebar',
  imports: [NgClass, RouterLink, RouterLinkActive, TitleCasePipe],
  templateUrl: './sidebar.html',
})
export class SidebarComponent {
  protected authService = inject(AuthService);
  protected layout = inject(LayoutService);
  protected userMenuOpen = signal(false);

  protected navItems = computed(() =>
    NAV_ITEMS.filter((item) => !item.module || this.authService.hasModuleAccess(item.module)),
  );

  get userInitials(): string {
    const user = this.authService.currentUser();
    const name = user?.firstName ?? user?.email ?? '';
    return name
      .split(' ')
      .slice(0, 2)
      .map((n) => n[0])
      .join('')
      .toUpperCase();
  }

  logout(): void {
    this.authService.logout();
  }
}
